export default __webpack_public_path__ + "static/media/admin.d37bb1c9.png";